import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container_flued" }
const _hoisted_2 = { class: "mb-3" }
const _hoisted_3 = ["href"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-play" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  id: "blocklyClassDiv",
  class: "w-100 h"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("toolbox", null, null, -1)
const _hoisted_8 = ["href"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-play" }, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_12 = [
  _hoisted_11
]

import { translation } from "../../lang/Translation";
import { SessionUser } from '../../utils/SessionUser';
import { ref,onMounted,onBeforeUnmount } from "vue";
import { DialogHandler } from './DialogHandler';
import CoreDialog from '../../../framework/components/dialog/CoreDialog.vue';
import { classRoomContext } from "../../pages/classroom/logics/ClassRoomContext";
import { GlobalImport } from '../../utils/GlobalImport';
import { createToolbox } from "../../blockly/toolbox_v2";
import { SessionMemory } from '../../utils/SessionMemory';

/**
 * 動的ラベル
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'ClassRoomProgramDialog',
  setup(__props) {

const t = translation; //
const dialogId = DialogHandler.classRoomProgramDialogId
const pageTitle = t.to("メンバープログラム","class_room_program")

// ブラウザバックで、ダイアログのバックドロップが残る問題の対処
onBeforeUnmount(() => {
  DialogHandler.hideDialog(dialogId)
})

// 閉じるボタンハンドラ
const closeDialog = ()=>{
  DialogHandler.hideDialog(dialogId)
}


onMounted(() => {
  DialogHandler.onOpenDialog(dialogId, async function () {
    console.log( classRoomContext.blockXml)

    document.getElementById("blocklyClassDiv").innerHTML = "";

    // toolboxを生成
    const toolBoxActual = createToolbox();
    toolBoxActual.notify();

    let zoomScale = 0.5;
    if(SessionMemory.instance.existsKey("workspace_scale")){
      zoomScale = parseFloat(SessionMemory.instance.getSession("workspace_scale"))
    }

    // ワークスペースを構築
    const Blockly = GlobalImport.getBlockly();
    const workspace = Blockly.inject("blocklyClassDiv", {
      media: "/node_modules/scratch-blocks/media/",
      toolbox: toolBoxActual.toXmlDom(),
      readOnly: true,
      move: {
        scrollbars: true,
        drag: true,
        wheel: true,
        
      },
      css:true,
      zoom: {
        controls: true,
        wheel: true,
        startScale: zoomScale,
        maxScale: 4.0,
        minScale: 0.2,
        scaleSpeed: 1.2,
      },
      collapse: true,
    });

    // ブロックでのマスタの初期表示
    const xml = classRoomContext.blockXml.value
    const dom = Blockly.Xml.textToDom(xml);
    Blockly.Xml.domToWorkspace(dom, workspace);

  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CoreDialog, {
    id: _unref(dialogId),
    "dialog-class": { 'modal-fullscreen': true },
    title: _unref(pageTitle)
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("a", {
          class: "btn btn-outline-dark mx-3",
          target: "_blank",
          href: _unref(classRoomContext).contentsUrl.value
        }, _hoisted_10, 8, _hoisted_8),
        _createElementVNode("button", {
          class: "btn btn-outline-dark",
          onClick: closeDialog
        }, _hoisted_12)
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("a", {
            class: "btn btn-outline-dark",
            target: "_blank",
            href: _unref(classRoomContext).contentsUrl.value
          }, _hoisted_5, 8, _hoisted_3)
        ]),
        _hoisted_6,
        _hoisted_7
      ])
    ]),
    _: 1
  }, 8, ["id", "title"]))
}
}

})